import { getContractSignUrl, type FeedItemResponseDto } from '@helios/frontend-api-v2-client';
import { openHome as openIntercom } from '@helios/frontend-core';
import { ApiFeedItemStatus, ApiFeedItemType } from '../../api/feed/types';
import { createContextUrl } from '../../utils/contextUrl';

export type FeedItemFunctionParams = {
  feedItem?: FeedItemResponseDto;
  projectId?: string;
  openURL?: (url: string) => void;
};

type FeedItemFunctionMapping = {
  [K in FeedItemResponseDto['type']]?: (params?: FeedItemFunctionParams) => boolean | void | Promise<boolean | void>;
};

export const FEED_ITEM_FUNCTION_MAP: FeedItemFunctionMapping = {
  [ApiFeedItemType.signContract]: async (params?: FeedItemFunctionParams) => {
    if (!params?.projectId) {
      throw new Error('Project ID is required for contract signing');
    }
    const { data } = await getContractSignUrl({ path: { id: params.projectId } });
    if (!data) {
      throw new Error('Failed to get contract sign URL');
    }
    window.location.href = data.signUrl;
  },
  [ApiFeedItemType.creditQualificationRequirement]: (params?: FeedItemFunctionParams) => {
    if (!params?.projectId || !params.openURL) return;
    params.openURL(createContextUrl('/credit-check', { id: params.projectId, type: 'project' }));
    return true;
  },
  [ApiFeedItemType.titleVerification]: (params?: FeedItemFunctionParams) => {
    if (params?.feedItem?.status === ApiFeedItemStatus.rejected) {
      openIntercom();
      return true;
    }
  },
  [ApiFeedItemType.kycMismatch]: () => {
    openIntercom();
    return true;
  },
};
